(function () {
  let sent = new Set();
  window.addEventListener('scroll', function () {
    // ページ全体の高さに対する現在のスクロール位置を計算
    const scrollPercent = Math.round(
      ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100,
    );

    // 閾値をチェック
    [25, 50, 75, 100].forEach((threshold) => {
      if (scrollPercent >= threshold && !sent.has(threshold)) {
        sent.add(threshold);
        // Shopifyカスタムピクセルへイベントを送信
        Shopify.analytics.publish('custom_scroll_event', {
          percent: threshold,
          page_path: window.location.pathname,
        });
      }
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  // 1. 共通設定：取得するキーのリスト(customイベント)
  const customEventKeys = [
    'module',
    'component',
    'screen',
    'content_type',
    'content_id',
    'position',
    'custom_info1',
    'custom_info2',
    'custom_info3',
  ];

  // GA推奨イベント名
  const recommendedEventNames = ['view_item_list', 'select_item'];
  // GA推奨イベント用のキーのリスト
  const recommendedEventKeys = [
    'item_list_id',
    'item_list_name',
    'item_id',
    'item_name',
    'item_list_position',
    'item_position',
  ];

  // 2. 共通関数：要素とイベント名を受け取り、ペイロードを生成して送信する
  const sendShopifyEvent = (element, eventName) => {
    // Shopifyオブジェクトが存在しない場合は処理しない
    if (!window.Shopify || !window.Shopify.analytics) return;

    const dataset = element.dataset;
    const payload = {};

    // event_name に "custom_" が含まれる場合、定義したキーをペイロードにセット
    if (eventName.includes('custom_')) {
      customEventKeys.forEach((key) => {
        payload[key] = dataset[key];
      });
    }

    // GA推奨イベントの場合、推奨イベント用キーをペイロードにセット
    if (recommendedEventNames.includes(eventName)) {
      recommendedEventKeys.forEach((key) => {
        if (dataset[key] !== undefined) {
          payload[key] = dataset[key];
        }
      });
    }

    // フィルターのチェックボックスは、クリック後の checked 状態から custom_info1 を動的に判定
    // （マッチ要素が input 本体でも、親の label でも実体の checkbox を探して判定する）
    if (eventName === 'custom_click' && dataset.module === 'filter') {
      const checkbox = element.matches('input[type="checkbox"]')
        ? element
        : element.querySelector('input[type="checkbox"]') ||
          element.closest('label')?.querySelector('input[type="checkbox"]');
      if (checkbox) {
        payload.custom_info1 = checkbox.checked ? '1' : '0';
      }
    }

    // アコーディオン・カートのディスカウント欄の開閉アクションを custom_info1 にセット（0: 開 -> 閉 / 1: 閉 -> 開）
    // details の開閉はクリックのデフォルト動作でイベント伝播後に起きるため、この時点の状態を反転させる
    const isToggle =
      dataset.component === 'accordion_icon' || (dataset.module === 'discount' && dataset.component === 'open');
    if (eventName === 'custom_click' && isToggle) {
      const details = element.closest('details');
      if (details) {
        payload.custom_info1 = details.open ? '0' : '1';
      }
    }

    // カスタムピクセルへ送信
    window.Shopify.analytics.publish(eventName, payload);
  };

  // ==========================================
  // 3. インプレッション計測の監視設定
  // ==========================================
  // 各イベントの設定に、個別の threshold を追加
  const impressionObservers = [
    { selector: '[data-impression="true"]', eventName: 'custom_impression', threshold: 0.5 }, // 小さいバナー等は50%で判定
    { selector: '[data-view_item_list="true"]', eventName: 'view_item_list', threshold: 0.0 }, // 縦に長い商品リストは0%で判定
  ].map(({ selector, eventName, threshold }) => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sendShopifyEvent(entry.target, eventName);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: threshold },
    );
    document.querySelectorAll(selector).forEach((el) => obs.observe(el));
    return { selector, eventName, obs };
  });

  // カートドロワー等、読み込み後に描画された要素も custom_impression の監視対象に加える
  // （クイック追加モーダル内に複製される商品詳細の要素は計測対象外）
  const impressionObserver = impressionObservers.find(({ eventName }) => eventName === 'custom_impression');
  const observeAddedImpression = (el) => {
    if (el.closest('quick-add-dialog')) return;
    impressionObserver.obs.observe(el);
  };
  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(impressionObserver.selector)) observeAddedImpression(node);
        node.querySelectorAll(impressionObserver.selector).forEach(observeAddedImpression);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // ==========================================
  // 4. クリック計測の監視設定
  // ==========================================
  // ロケール文言・アプリブロック・管理画面入力のリッチテキスト内のリンクは Liquid で属性を付けられないため、
  // クリック時（キャプチャ段階）に計測属性を付与してから下の委譲リスナで送信する
  const linkRules = [
    {
      selector: '.selling-period__notes a',
      module: 'shipping_info',
      component: 'selling_period',
      screen: 'product_detail',
    },
    {
      selector: '.product-notes a[href*="/policies/legal-notice"]',
      module: 'product_links',
      component: 'cancel_policy',
      screen: 'product_detail',
    },
    { selector: '.cart-page .cart-totals__tax-note a', module: 'shipping_info', component: 'detail', screen: 'cart' },
    {
      selector: 'cart-drawer-component .cart-totals__tax-note a',
      module: 'shipping_info',
      component: 'detail',
      screen: 'cart_drawer',
    },
  ];

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      linkRules.forEach(({ selector, module, component, screen }) => {
        const link = event.target.closest(selector);
        if (!link || link.dataset.clicked) return;

        Object.assign(link.dataset, { clicked: 'true', module, component, screen });
      });
    },
    true,
  );

  document.body.addEventListener('click', function (event) {
    // クリックされた要素の親を辿り、対象の data 属性を持つ要素を取得
    const clickedElement = event.target.closest('[data-clicked="true"]');
    const selectItemElement = event.target.closest('[data-select_item="true"]');
    const targetElement = clickedElement || selectItemElement;

    if (targetElement) {
      // 合成クリックは追従バー側で計測済み
      if (!event.isTrusted && targetElement.getAttribute('data-module') === 'add_to_cart') {
        return;
      }

      // クイック追加モーダル内に複製される商品詳細の要素はスプシに定義が無いため計測対象外
      if (targetElement.getAttribute('data-screen') === 'product_detail' && event.target.closest('quick-add-dialog')) {
        return;
      }

      // 親がハンバーガーメニューであり、かつ、クリック地点がメニューの中身(#menu-drawer)なら中断
      if (targetElement.getAttribute('data-module') === 'hamburger_menu' && event.target.closest('#menu-drawer')) {
        return;
      }

      // マッチした属性に応じてイベント名を決定
      const eventName = clickedElement ? 'custom_click' : 'select_item';
      sendShopifyEvent(targetElement, eventName);
      toggleHamburgerState(targetElement);
    }
  });

  /**
   * ハンバーガーメニューの開閉状態（data-custom_info1）を切り替える関数
   * @param {HTMLElement} element - 対象となるDOM要素
   */
  function toggleHamburgerState(element) {
    // data-module="hamburger_menu" を持っている場合のみ実行
    if (element.getAttribute('data-module') === 'hamburger_menu') {
      const currentStatus = element.getAttribute('data-custom_info1');

      if (currentStatus === 'open') {
        element.setAttribute('data-custom_info1', 'close');
      } else if (currentStatus === 'close') {
        element.setAttribute('data-custom_info1', 'open');
      }
    }
  }
});
